<template>
  <div class="tabbar">
    <div
      v-for="(item, index) in tabbarList"
      :key="item.id"
      :to="item.to"
      class="tabbar-item flex-center"
      :class="active === index ? 'active' : ''"
      @click="beforeChange(item, index)"
    >
      <img
        :src="active === index ? item.icon.active : item.icon.inactive"
        class="icon-img"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TabBar2',
    components: {},
    props: ['tabbarList', 'value'],
    data() {
      return {
        active: this.value,
      }
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {
      value(val) {
        this.active = val
      },
      active(val) {
        this.$emit('input', val)
      },
    },
    methods: {
      beforeChange(item, index) {
        const queries = Object.assign({}, this.$route.query)
        if (item.id === 'order' && queries.from) {
          delete queries.from
        }
        this.active = index
        this.$router.push({
          path: item.to,
          query: queries,
        })
        this.$emit('beforeChange', index)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tabbar {
    background: linear-gradient(
      180deg,
      #333343 0%,
      rgba(51, 51, 67, 0.95) 100%
    );
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
    border-radius: 100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 750px;
    height: 180px;
    padding: 30px 75px;
    box-sizing: border-box;
    position: fixed;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10; // 不低于 logout 登出按钮的层级，避免从账户页退出时被盖住
    &-item {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      cursor: pointer;

      &.active {
        background: $orange-linear;
      }

      .icon-img {
        height: 100%;
        display: block;
      }
    }
  }
</style>
